import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getToken } from '../../../../features/token/tokenSaver';
import { RingLoader } from 'react-spinners';
import '../AdvertiserDashboardNewCampaign/AdvertiserDashboardNewCampaign.css';

export default function AdvertiserPrepayStripeSuccess() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const token = useSelector(getToken);
    const sessionId = searchParams.get('session_id');

    const [phase, setPhase] = useState('working');
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        let cancelled = false;

        const run = async () => {
            if (!sessionId) {
                setPhase('error');
                setErrorMessage('Missing payment session. Start again from Prepay.');
                return;
            }

            if (!token) {
                return;
            }

            try {
                const res = await fetch(
                    `${process.env.REACT_APP_API_URL}/advertiser/campaign-stripe/finalize-prepay`,
                    {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: token,
                        },
                        body: JSON.stringify({ sessionId }),
                    }
                );

                const data = await res.json().catch(() => ({}));
                if (!res.ok) {
                    throw new Error(data.error || 'Could not complete your reservation.');
                }

                if (!cancelled) {
                    try {
                        sessionStorage.removeItem('invert_new_campaign_meta');
                    } catch {
                        /* ignore */
                    }
                    setPhase('done');
                    navigate('/advertiserDashboard/campaigns', {
                        replace: true,
                        state: {
                            prepaySuccess: true,
                            emailSent: data.emailSent,
                        },
                    });
                }
            } catch (e) {
                if (!cancelled) {
                    setPhase('error');
                    setErrorMessage(e.message || 'Something went wrong.');
                }
            }
        };

        run();
        return () => { cancelled = true; };
    }, [sessionId, token, navigate]);

    if (phase === 'error') {
        return (
            <div className="advertiserDashboardContainerCampaigns">
                <div className="adminDashboardScreenPageContainer">
                    <div className="campaignModalAlert" style={{ maxWidth: '640px' }}>
                        <span className="registeredScreensTitle advertiserListTitle">Payment received</span>
                        <p style={{ padding: '1rem', textAlign: 'center', color: '#C52F00' }}>{errorMessage}</p>
                        <Link
                            className="advertiserRegisterSubmitBtn"
                            style={{ display: 'inline-block', textDecoration: 'none', textAlign: 'center' }}
                            to="/advertiserDashboard/prepay"
                        >
                            Back to Prepay
                        </Link>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="advertiserDashboardContainerCampaigns">
            <div className="adminDashboardScreenPageContainer">
                <div className="campaignModalAlert" style={{ maxWidth: '640px' }}>
                    <span className="registeredScreensTitle advertiserListTitle">Confirming payment…</span>
                    <p style={{ padding: '1rem', textAlign: 'center' }}>
                        Creating your reservation and sending your receipt email. Please wait.
                    </p>
                    <div style={{ display: 'flex', justifyContent: 'center', padding: '1rem' }}>
                        <RingLoader color="#C52F00" loading size={50} aria-label="Loading" />
                    </div>
                </div>
            </div>
        </div>
    );
}
